export default function () {
  return {
    page: 1,
    totalPages: 0,
    perPage: 15,
    searchParams: {},
    items: [],
    fields: [
      {
        key: 'title',
        label: 'Título'
      },
      {
        key: 'enabled',
        label: 'Status'
      },
      {
        key: 'actions',
        label: 'Ações'
      }
    ]
  }
}
